import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission) {
    const permissionLevel = user.permission_level || 'user';

    if (requiredPermission === 'global_admin' && permissionLevel !== 'global_admin') {
      return <Navigate to="/" replace />;
    }

    if (requiredPermission === 'company_admin') {
      if (permissionLevel !== 'global_admin' && !user.can_manage_users) {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
